import {Observable} from 'rxjs';
import {get} from 'lodash';
import {Http} from '@angular/http';
import {Injectable} from '@angular/core';
import {ProfileState} from '../entity';
import {ProfileAccountsFilteringModel} from '../entity/accounts-filter-model';
import {CustomerAccount, Currency} from '../../../../../shared/api/entity';
import {SearchApiObservableService} from '../../../../../shared/filter/search-api-observable.service'
import {ClientUser} from '../entity/client-user';

@Injectable()
export class CustomerAccountsService {

    constructor(private _http: Http,
                private _searchApiObservableService: SearchApiObservableService) {
    }

    getProfileStatesForRegisteredClients(): Observable<[ProfileState]> {
        return this._http.get('/api/backoffice/customers/registered/account/states').map(response => response.json());
    }

    getCurrencies(): Observable<[Currency]> {
        return this._http.get('/api/client/dictionary/currencies')
            .map(response => response.json())
            .map(response => get(response, 'currencies', []));
    }

    searchAccounts(filterModel: ProfileAccountsFilteringModel, profileId: number): Observable<CustomerAccount[]> {
        return this._searchApiObservableService
            .searchRequestForUrl(`/api/backoffice/customers/${profileId}/accounts/search`, filterModel)
            .map(response => get(response, 'accounts', []));
    }

    getClientUser(prifileId: number, userName: string): Observable<ClientUser> {
        let encodedUserName = encodeURIComponent(userName);

        return this._http
            .get(`/api/backoffice/customers/${prifileId}/client?username=${encodedUserName}`)
            .map(response => response.json());
    }

    changeAccountState(accountId: number, state: number, reason?: string): Observable<CustomerAccount> {
        let requestBody = {
            state: `${state}`
        };

        if (reason) {
            requestBody['reason'] = reason;
        }
        return this._http
            .patch(`/api/backoffice/customers/${accountId}/state`, requestBody)
            .map(response => response.json());
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/api/service/customer-accounts.service.ts